import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import ExpertDataService from "../../services/Expert";
import { BsPencil } from "react-icons/bs";
import { IoMdAdd } from "react-icons/io";
import { useDisclosure } from "@chakra-ui/react";
import { defaultTiming } from "../../Config/Expert";
import { CreateEventModal } from "../Modals/CreateEventModal";
import { ClearEventModal } from "../Modals/ClearEventModal";
import { MdOutlineDeleteForever } from "react-icons/md";
export const ExpertCustomCalender = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [clickedDay, setClickedDay] = useState<any>("");
  const [modal, setModal] = useState("");
  const [timing, setTiming] = useState(defaultTiming);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const handleEvent = (newTimings: any) => {
    setTiming(newTimings);
  };
  const fetchData = async () => {
    ExpertDataService.getCalenderInfo(id)
      .then((res: any) => {
        const data = res.data;
        Object.keys(data).length === 0
          ? setTiming(defaultTiming)
          : setTiming(data);
      })
      .catch((err: any) => {
        console.log(err);
      });
  };
  const handleRemove = async (dayName: string) => {
    ExpertDataService.deleteCalenderInfo(id, dayName)
      .then((res: any) => {
        fetchData();
      })
      .catch((err: any) => {
        console.log(err);
      });
  };
  useEffect(() => {
    fetchData();
  }, []);
  return (
    <>
      <div className="page_title py-2">Experts - App Experts</div>
      <div className="p-3">
        <div className="row m-0 mt-5 pt-3 justify-content-between align-items-center">
          <div className="col-sm-8 p-lg-0">
            <div className="btn-group" role="group">
              <button
                type="button"
                className="btn action-btn"
                onClick={() => navigate(`/experts/edit/${id}`)}
              >
                Edit
              </button>
            </div>
            <div className="btn-group" role="group">
              <button
                type="button"
                className="btn action-btn"
                onClick={() => navigate(`/experts/view/${id}`)}
              >
                View
              </button>
            </div>
            <div className="btn-group" role="group">
              <button
                type="button"
                className="btn action-btn"
                onClick={() => navigate(`/calender/leave/${id}`)}
              >
                Leaves
              </button>
            </div>
          </div>
        </div>
        <div className="centered-container">
          {timing && (
            <table className="custom-table">
              <thead>
                <tr>
                  <th>Days</th>
                  <th className="time-slots">Time-slots</th>
                  <th>Add</th>
                  <th>Edit</th>
                  <th>Remove</th>
                </tr>
              </thead>
              <tbody>
                {Object.entries(timing).map(([key, value]: any) => {
                  return (
                    <tr key={key}>
                      <td>{key.charAt(0).toUpperCase() + key.slice(1)}</td>
                      <td>
                        {value.length > 0
                          ? value
                              .map(
                                (item: { start: any; end: any }) =>
                                  `${item.start}-${item.end}`
                              )
                              .join(", ")
                          : "No slots available"}
                      </td>
                      <td>
                        <div
                          className="table-icon  pointer"
                          onClick={() => {
                            setModal("CreateEventModal");
                            setClickedDay(key);
                            onOpen();
                          }}
                        >
                          <IoMdAdd />
                        </div>
                      </td>
                      <td>
                        <div
                          className="table-icon pointer"
                          onClick={() => {
                            setModal("ClearEventModal");
                            setClickedDay(key);
                            onOpen();
                          }}
                        >
                          <BsPencil />
                        </div>
                      </td>
                      <td>
                        <MdOutlineDeleteForever
                          className="deleteButton pointer"
                          onClick={() => handleRemove(key)}
                        />
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          )}
        </div>
        {modal === "CreateEventModal" && (
          <CreateEventModal
            isOpen={isOpen}
            timing={timing}
            onClose={onClose}
            func={handleEvent}
            targetDay={clickedDay}
            id={id}
          />
        )}
        {modal === "ClearEventModal" && (
          <ClearEventModal
            isOpen={isOpen}
            timing={timing}
            onClose={onClose}
            func={handleEvent}
            targetDay={clickedDay}
            id={id}
          />
        )}
      </div>
    </>
  );
};
